import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { Product } from '../components/Product.js';
import { AddButtonContainer } from './AddButtonContainer.js';
import { AddButtonSuccessMessageContainer } from './AddButtonSuccessMessageContainer.js';
import { RemoveButtonContainer } from './RemoveButtonContainer.js';

const UpsellItemContainer = (item)=>{
    const [addedLineItem, setAddedItem] = React.useState(null);
    const [successMessage, setSuccessMessage] = React.useState(false);
    const itemDraft = {
        sku: item.sku,
        quantity: 1,
        type: 'regular'
    };
    const onAddedSuccess = React.useCallback(([lineItem])=>{
        setSuccessMessage(true);
        setTimeout(()=>{
            setSuccessMessage(false);
        }, 2000);
        setAddedItem(lineItem);
    }, [
        setSuccessMessage,
        setAddedItem
    ]);
    const onRemovedSuccess = React.useCallback(()=>{
        setAddedItem(null);
    }, [
        setAddedItem
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('upsell-item', {
            'upsell-item--is-added': addedLineItem
        })
    }, addedLineItem && /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        className: "upsell-item__checkmark"
    }), /*#__PURE__*/ React.createElement(Product, {
        body: item.body,
        price: item.price,
        title: item.title,
        imageUrl: item.imageUrl,
        tag: item.tag
    }), /*#__PURE__*/ React.createElement("div", {
        className: "upsell-item__action-button"
    }, !addedLineItem && /*#__PURE__*/ React.createElement(AddButtonContainer, {
        lineItemDrafts: [
            itemDraft
        ],
        onSuccess: onAddedSuccess
    }), addedLineItem && !successMessage && /*#__PURE__*/ React.createElement(RemoveButtonContainer, {
        lineItem: addedLineItem,
        onSuccess: onRemovedSuccess
    }), successMessage && /*#__PURE__*/ React.createElement(AddButtonSuccessMessageContainer, null)));
};

export { UpsellItemContainer };
//# sourceMappingURL=UpsellItemContainer.js.map
